import React, { useEffect, useRef, useState, useContext } from "react";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button, Container, Stack, Menu, MenuItem, Box, Modal, Dialog, Chip, IconButton, Tooltip} from "@mui/material";

import DownloadIcon from "@mui/icons-material/GetApp";
import CloseIcon from "@mui/icons-material/CloseOutlined"
import PublishIcon from "@mui/icons-material/Publish";
import AttachmentIcon from '@mui/icons-material/Attachment';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LinkIcon from "@mui/icons-material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReStoreIcon from '@mui/icons-material/RotateLeft';
import DriveFileMoveIcon from '@mui/icons-material/FolderSpecial';
import AddIcon from '@mui/icons-material/Add';
import { RemoveCircleOutline } from "@mui/icons-material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import dayjs from 'dayjs';
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";

import { GlobalContext } from '../../../context/hoa-global-context';
import datastore from "../../../store/hoa-datastore";
import DashboardService from "../../../services/hoa-dashboard-api-service";
import {decodeNestedURI} from "../../../utility/decode-url";
import config from '../../../hoa-config';
import SuccessMessage from "../../../components/success-message/hoa-success-message";
import { saveNewLogsInDatastore } from "../../../utility/change-log";
import { getFieldNamesWithInvisibleFields } from "../../../utility/helper";
import CustomDateField from "../../../Container/custom-date-field";
import SourceIDVerificationCard from "../hoa-forms/common/SourceIDVerificationCard";
import useFieldDisabled from "../../../hooks/useFieldDisabled";

const hoaPath = 'hoa'

const urlCheck = (url: string) => {
	if (url) {
		return url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
	}
	return "";
}

const isUrlExpired = (url:string) => {
	const urlParams = new URLSearchParams(url);
	let expiredTimeStamp : any = urlParams.get('EXPIRES');
	if(!expiredTimeStamp) {
		expiredTimeStamp = urlParams.get('Expires');
	}
	expiredTimeStamp = parseInt(expiredTimeStamp);
	expiredTimeStamp *= 1000;

	const expiredDateObj = new Date(expiredTimeStamp);

	const d = new Date();
	return expiredDateObj < d;
}
interface TableCompPoops {
	updateModalOpen: any;
	open: boolean;
	view: string;
	downloadModalOpen: boolean;
	updateDownloadModalOpen: any;
	setDownloadAbleFiles: any;
	document: any;
	setSelectedDocumentDetails: any;
	getFormatedDate: any;
	DownloadDoc:any;
	docTitle:any;
	singleFieldPermissionCheck?:any;
	isDocumentDisabled: any;
}

export default function DocumentsComponent({
	currentHoa,
	setCurrentHoa,
	documents,
	selectedValues,
	hoa,
	view,
	previousHoa,
	updateSelectedValues,
	updateHoaData,
	setDocumentWarning,
	checkDocumentWarning,
	restrictedFields
}: any) {
	const [document, setDocumentDetails] = useState(
		documents || {
			"CCNR Document": {},
			"By-laws Document": {},
			"Rules and Restrictions": {},
			"Articles of Incorporation": {},
			"HOA Tenant or Lease Registration/Renewal Form": {},
			"Other Documents": {},
			"Guidelines & Policies": {},
			"Plat Maps": {},
			"HOA Updates & Announcements": {},
			"HOA Forms": {}
		}
	);
	const [open, toggleOpen] = useState(false);
	const [deleteOpen, toggleDeleteOpen] = useState(false);
	const [downloadOpen, toggleDownloadOpen] = useState(false);
	const [downloadAbleFiles, setDownloadAbleFiles] = useState([]);
	const [selectedDocument, setSelectedDocument] = useState({});
	const [selectedDocumentDetails, setSelectedDocumentDetails] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [title, setTitle] = useState('');
	const { selectedHoaDocuments, updateSelectedHoaDocuments, hoaDocumentToBeDeleted, updateHoaDocumentToBeDeleted } = useContext<any>(GlobalContext);
	const [success, setSuccess] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const { isDocumentDisabled } = useFieldDisabled();

	const handleClose = () => {
		toggleOpen(false);
	};
	const handleDeleteClose = () => {
		toggleDeleteOpen(false);
	};
	const handleDownloadClose = () => {
		toggleDownloadOpen(false);
	};

	let isDetailsEmpty = true;
	const docTitle = Object.keys(selectedDocumentDetails)[0];
	const values = Object.values(selectedDocumentDetails);
	if (Object.values(values).length > 0 && Object.keys(values[0]).length !== 0) {
		isDetailsEmpty = false;
	}
	if (selectedHoaDocuments[docTitle] && selectedHoaDocuments[docTitle]?.files && selectedHoaDocuments[docTitle]?.files.length>0) {
		isDetailsEmpty = false;
	}
	if(hoaDocumentToBeDeleted[docTitle]){
		isDetailsEmpty = false;
	}

	const getFormatedDate = (date: Date) => {
		if (!date) return;

		return new Date(date).toLocaleString();
	};

	const generateNewDocumentUrl = async (url: string,title?:string,index?:number,name?:string) => {
		setIsLoading(true)
		let extractUrl = url.split('?')[0];
		let extractUrlArray = extractUrl.split('/');
		let fileName = decodeNestedURI(extractUrlArray[extractUrlArray.length-1]);

		// S3 dont allow special characters in the file name, this two document has special characters in the object name
		// HOA Updates & Announcements folder name is HOA-Updates- in S3 bucket
		// Guidelines & Policies folder name is Guidelines- in S3 bucket
		// If any changes for this, please also check public api for signed url
		if (title === "HOA Updates & Announcements" || title === "Guidelines & Policies") {
			title = title.split("&")[0];
		}
		
		// Document title is used to create the folder in S3 bucket and file name is used to get the file from the folder
		// If the file name has space and /, it will be replaced with "-"

		// position of the hoaId can differ based on bucket name
		let hoaId = extractUrlArray[2].includes("im-production") ? extractUrlArray[5] : extractUrlArray[4];

		let path = `${hoaPath}/${hoaId}/documents/${title.replace(/[ /]/g, "-")}/${fileName}`
		const signedUrl = await DashboardService.getSignedUrl(path)
		setIsLoading(false);
		return signedUrl.data;
	}

	const DownloadDoc = async (url: string,title?:string,index?:number,name?:string) => {
		const newUrl = await generateNewDocumentUrl(url, title, index, name);
		window.open(newUrl, "_blank");
	};

	const createLogs = async (status:string,objectId:string,prevState?:any,updatedState?:any,extensions?:any) => {
		// delete parseObjects
        let prev = {...prevState}
		delete prev._parseObject
        if(prev.municipality){
            delete prev.municipality._parseObject
        }
		let update = {...updatedState}
        if(update.municipality){
            delete update.municipality._parseObject
        }
		delete update._parseObject

		// set primaryEvent
        var events:any = [];
		var primaryEvent = config.changeLongActionsHoa[status];

		// manage extensions
		if(Array.isArray(extensions) && extensions.length > 0) {
			extensions.map(extension => {
				events.push(`${primaryEvent} ${extension}`);
			});
		}
		else {
			events.push(primaryEvent);
		}

        const logMessage = {
            events:events,
            user: datastore.ownerInformation.name,
            prevState:prev,
            updatedState:update,
            type:'Hoa',
            tagTypeId:objectId,
        }
        const result = await DashboardService.createLogs(logMessage);
        saveNewLogsInDatastore(result.data, datastore);
    }

	const singleFieldPermissionCheck=(fieldName:string)=>{
        if(!restrictedFields || (restrictedFields && !restrictedFields.length)){
            return true
        } else if((Boolean(restrictedFields.length) && !restrictedFields.includes(fieldName))){
            return true
        }
        return false
    }

	return (
		<div style={{ display: "flex" }}>
			<SuccessMessage
				success={success}
				setSuccess={setSuccess}
				message={successMessage}
			/>  
			<GeneratingSignedUrl isLoading={isLoading} />
			<DownloadAttachmentComp
				downloadOpen={downloadOpen}
				handleDownloadClose={handleDownloadClose}
				downloadAbleFiles={downloadAbleFiles}
				DownloadDoc={DownloadDoc}
				title={title}
			/>
			{
				view === "update" ?
				<>
				{open && 
					<UploadAttachmentComp
						open={open}
						handleClose={handleClose}
						selectedDocumentDetails={selectedDocumentDetails}
						setSelectedDocumentDetails={setSelectedDocumentDetails}
						setDocumentDetails={setDocumentDetails}
						document={document}
						selectedValues={selectedValues}
						updateSelectedValues={updateSelectedValues}
						hoa={hoa}
						previousHoa={previousHoa}
						updateHoaData={updateHoaData}
						setDocumentWarning={setDocumentWarning}
						checkDocumentWarning={checkDocumentWarning}
						DownloadDoc={DownloadDoc}
						createLogs={createLogs}
						selectedHoaDocuments={selectedHoaDocuments}
						updateSelectedHoaDocuments={updateSelectedHoaDocuments}
					/>}
					<DeleteAttachmentComp
						deleteOpen={deleteOpen}
						toggleDeleteOpen={toggleDeleteOpen}
						handleDeleteClose={handleDeleteClose}
						selectedDocument={selectedDocument}
						setSelectedDocument={setSelectedDocument}
						selectedDocumentDetails={selectedDocumentDetails}
						setSelectedDocumentDetails={setSelectedDocumentDetails}
						setDocumentDetails={setDocumentDetails}
						document={document}
						selectedValues={selectedValues}
						updateSelectedValues={updateSelectedValues}
						hoa={hoa}
						updateHoaData={updateHoaData}
						setDocumentWarning={setDocumentWarning}
						DownloadDoc={DownloadDoc}
						createLogs={createLogs}
						hoaDocumentToBeDeleted={hoaDocumentToBeDeleted}
						updateHoaDocumentToBeDeleted={updateHoaDocumentToBeDeleted}
					/>
				</> : ''
			}
			<div style={{ width: "808px" }}>
				<TableComponent
					view={view}
					open={open}
					updateModalOpen={toggleOpen}
					updateDownloadModalOpen={toggleDownloadOpen}
					downloadModalOpen={downloadOpen}
					setDownloadAbleFiles={setDownloadAbleFiles}
					document={document}
					setSelectedDocumentDetails={setSelectedDocumentDetails}
					getFormatedDate={getFormatedDate}
					DownloadDoc={DownloadDoc}
					docTitle={setTitle}
					singleFieldPermissionCheck={singleFieldPermissionCheck}
					isDocumentDisabled={isDocumentDisabled}
				/>
			</div>
			<div style={{ width: "326px", padding: "24px", height: "inherit" }}>
				{isDetailsEmpty && (
					<Stack direction={"column"}>
						<span className="text-3E3E3E-16px">Document Details</span>
						<Stack direction={"column"} alignItems="center">
							<img
								style={{ cursor: "pointer", width: "200px" }}
								src="images/logo/doc-wallpaper.png"
							/>
							<span className="text-787878-14px">
								Please upload file first & select it to view details.
							</span>
						</Stack>
					</Stack>
				)}
				{!isDetailsEmpty && (
					<SelectedUploadedDoc
						view={view}
						getFormatedDate={getFormatedDate}
						deleteOpen={deleteOpen}
						toggleDeleteOpen={toggleDeleteOpen}
						selectedDocument={selectedDocument}
						setSelectedDocument={setSelectedDocument}
						selectedDocumentDetails={selectedDocumentDetails}
						setSelectedDocumentDetails={setSelectedDocumentDetails}
						selectedValues={selectedValues}
						document={document}
						setDocumentDetails={setDocumentDetails}
						DownloadDoc={DownloadDoc}
						updateHoaData={updateHoaData}
						hoa={hoa}
						updateSelectedValues={updateSelectedValues}
						selectedHoaDocuments={selectedHoaDocuments}
						currentHoa={currentHoa}
						setCurrentHoa={setCurrentHoa}
						hoaDocumentToBeDeleted={hoaDocumentToBeDeleted}
						updateHoaDocumentToBeDeleted={updateHoaDocumentToBeDeleted}
						createLogs={createLogs}
						isDocumentDisabled={isDocumentDisabled}
					/>
				)}
			</div>
		</div>
	);
}

const TableComponent = (props: TableCompPoops) => {
	const {view, updateModalOpen, open, downloadModalOpen, updateDownloadModalOpen, setDownloadAbleFiles, docTitle, document, setSelectedDocumentDetails, getFormatedDate, DownloadDoc, singleFieldPermissionCheck, isDocumentDisabled } = props;
	const [isSelectedRow, setIsSelectedRow] = useState("");

	const onTableRowClick = (title: string) => {
		setSelectedDocumentDetails({ [title]: document[title] });
	};

	const onUpdateClick = (title: string) => {
		updateModalOpen(!open);
		setSelectedDocumentDetails({ [title]: document[title] });
	};

	const onDownloadClick = (files: any, title: string) => {
		updateDownloadModalOpen(!downloadModalOpen);
		setDownloadAbleFiles(files);
		docTitle(title)
	}

	function MouseOver(event: any, title: string) {
		setIsSelectedRow(title);
	}
	function MouseOut(event: any) {
		setIsSelectedRow("");
	}

	return (
		<TableContainer
			component={"div"}
			style={{
				height: window.innerHeight - datastore.responsiveHeightWithtab - 1,
				overflow: "auto",
			}}
		>
			<Table stickyHeader>
				<TableHead>
					<TableRow
						sx={{
							"& th": {
								color: "#3E3E3E",
								backgroundColor: "#F7F7F7",
							},
						}}
					>
						<TableCell>
							<span className="text-3E3E3E-14px bold">Document Name</span>
						</TableCell>
						<TableCell>
							<span className="text-3E3E3E-14px bold">Last Uploaded</span>
						</TableCell>
						<TableCell>
							<span className="text-3E3E3E-14px bold">Status</span>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{Object.keys(document).map((title: string, index: number) => {
						const status = document[title]?.lastUpdated ? "Uploaded" : "Pending";
						if(!singleFieldPermissionCheck || singleFieldPermissionCheck(title)){
						return (
							<TableRow
								onMouseOver={(e) => MouseOver(e, title)}
								onMouseOut={MouseOut}
								onClick={() => onTableRowClick(title)}
								className="doc-row-container"
								key={index}
							>
								<TableCell width={"150px"}>
									<span className="text-5B5B5B-14px-400-20">{title}</span>
								</TableCell>
								<TableCell width={"150px"}>
									<span className="text-5B5B5B-14px-400-20">
										{getFormatedDate(document[title]?.lastUpdated) || "N/A"}
									</span>
								</TableCell>
								<TableCell>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<div
											style={{ background: "#EDE7F6" }}
											className="document-status-container"
										>
											<span style={{ padding: "0px 10px" }}>{status}</span>
										</div>
										{isSelectedRow === title && (
											<Tooltip title="Download Document">
											<IconButton
												disabled={status === "Uploaded" ? false : true}
												onClick={() => {
													onDownloadClick(document[title]?.files, title)
												}}
											>
												<DownloadIcon
													style={{
														width: "20px",
														height: "20px",
														cursor: "pointer",
													}}
												/>
											</IconButton>
											</Tooltip>
										)}
										{isSelectedRow === title && view === "update" ? (
											<Button
												onClick={() => onUpdateClick(title)}
												disabled={isDocumentDisabled(title)}
												style={{
													width: "104px",
													height: "30px",
													background: "white",
													textTransform: "capitalize",
												}}
												startIcon={
													<PublishIcon
														style={{
															width: "20px",
															height: "20px",
														}}
													/>
												}
											>
												<span className="text-3E3E3E-14px normal">
													Upload
												</span>
											</Button>
										) : ''}
									</div>
								</TableCell>
							</TableRow>
						);
					 }
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const DownloadAttachmentComp = ({
	downloadOpen,
	downloadAbleFiles,
	handleDownloadClose,
	DownloadDoc,
	title
}: any) => {

	const onClose = () => {
		handleDownloadClose();
	};

	return (
		<Modal disableEnforceFocus open={downloadOpen} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "auto",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
						<h3 style={{color: '#3E3E3E'}}>Download Documents</h3>
						<IconButton
							onClick={() => onClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
					<table className='table-container'>
						<thead style={{ margin: '0 auto' }}>
							<tr className="table-header">
								<th className="table-header-title-container">Name</th>
								<th className="table-header-title-container">Last Added</th>
								<th className="table-header-title-container"></th>
							</tr>
						</thead>
						<tbody style={{ height: 'auto', width: 'auto' }}>
							{downloadAbleFiles.length>0 && downloadAbleFiles.map((row: any, index: number) => (
								<tr className="table-body" key={index}>
									<td className="table-body-container">{row.name}</td>
									<td className="table-body-container">{row.uploadedTime}</td>
									<td className="table-body-container">
										<IconButton
											onClick={() => {
												DownloadDoc(
													urlCheck(row.url),
													title,
													index,
													row.name
												);
											}}>
											<DownloadIcon
												style={{
													width: "20px",
													height: "20px",
													cursor: "pointer",
												}}
											/>
										</IconButton>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Container>
		</Modal>
	)
}

const DeleteAttachmentComp = ({
	deleteOpen,
	toggleDeleteOpen,
	handleDeleteClose,
	selectedDocument,
	setSelectedDocument,
	selectedDocumentDetails,
	setSelectedDocumentDetails,
	setDocumentDetails,
	document,
	selectedValues,
	updateSelectedValues,
	hoa,
	updateHoaData,
	setDocumentWarning,
	DownloadDoc,
	createLogs,
	hoaDocumentToBeDeleted,
	updateHoaDocumentToBeDeleted
}: any) => {
	const [error, setError] = useState({ link: false, files: false });
	const [isLoading, setLoading] = useState(false);
	const title = Object.keys(selectedDocumentDetails)[0];

	const handleDelete = async () => {
		let arr = selectedDocumentDetails[title]?.files.filter((item: any) => {
			return item.name != selectedDocument.name;
		});
		let toBeDeleted = {
			...hoaDocumentToBeDeleted,
			[title]: hoaDocumentToBeDeleted[title] ? [...hoaDocumentToBeDeleted[title], selectedDocument] : [selectedDocument]
		}
		let updateDocumentObject = {
			...selectedDocumentDetails,
			[title]: {
				...selectedDocumentDetails[title],
				files: arr
			}
		}
		const updatedDocuments = {
			...document,
			[title]: updateDocumentObject[title]
		};
		setSelectedDocumentDetails(updateDocumentObject);
		updateHoaDocumentToBeDeleted(toBeDeleted);
		setDocumentDetails(updatedDocuments);
		selectedValues.documents = updatedDocuments;
		updateSelectedValues(selectedValues);
		setDocumentWarning(false);
		handleDeleteClose();
	};
	const onClose = () => {
		handleDeleteClose();
	};

	return (
		<Modal open={deleteOpen} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>
					
					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}

const UploadAttachmentComp = ({
	open,
	handleClose,
	selectedDocumentDetails,
	setSelectedDocumentDetails,
	setDocumentDetails,
	document,
	selectedValues,
	updateSelectedValues,
	hoa,
	view,
	previousHoa,
	updateHoaData,
	setDocumentWarning,
	DownloadDoc,
	createLogs,
	selectedHoaDocuments,
	updateSelectedHoaDocuments,
	checkDocumentWarning
}: any) => {
	const title = Object.keys(selectedDocumentDetails)[0];
	const [error, setError] = useState({ link: false, files: false});
	const [sourceFileInfo, setSourceFileInfo] = useState([]);
	const [loading, setLoading] = useState(false);
	const [cleared, setCleared] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => {};	
  }, [cleared]);

	useEffect(() => {
		setError({ link: false, files: false})
	}, [selectedDocumentDetails]);

	const onUploadClick = async () => {
		const tempState = {...selectedHoaDocuments[title]};

		if(sourceFileInfo.length > 0){
			if(tempState.files && tempState.files.length>0){
				tempState.files = [...new Set([...tempState.files, ...sourceFileInfo])];
			}else{
				tempState.files = sourceFileInfo;
			}
		}

		if(selectedHoaDocuments[title]?.hyperLink){
			tempState.hyperLink = tempState?.hyperLink.filter((item: any) => item != "");
			if(!selectedHoaDocuments[title]?.AmendmentDate && document[title]?.amendmentDate){
			   tempState.AmendmentDate = document[title].amendmentDate;
		    }
		}
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)

		handleClose();
	};

	const onClose = () => {
		delete selectedHoaDocuments[title]
		updateSelectedHoaDocuments(selectedHoaDocuments)
		handleClose();
	};

	const handleDocument = (value: any, key: any) => {
		const tempState = {...selectedHoaDocuments[title]};
		tempState[key] = value;
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)
	}

	useEffect(() => {
		const tempState = {...selectedHoaDocuments[title]};
		if(!tempState.hyperLink){
			tempState['hyperLink'] = [""];
		}
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		if (tempState?.files && tempState.files.length > 0) {
			setSourceFileInfo(tempState.files);
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)
	},[])

	const handleHyperLink = (value: string, index: number) => {
		const tempState = {...selectedHoaDocuments[title]};
		tempState.hyperLink[index] = value;
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)
	}

	const addMoreLink = () => {
		const tempState = {...selectedHoaDocuments[title]};
		tempState?.hyperLink.push("");
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)
	}

	const removeHyperLink = (index: number) => {
		const tempState = {...selectedHoaDocuments[title]};
		tempState.hyperLink = tempState?.hyperLink.filter((link: string, idx: number) => idx !== index);
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo)
	}
	const handleClearAmendmentDate=()=>{
       	delete selectedHoaDocuments[title]?.AmendmentDate
		setCleared(true)
	}

	const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: '',
			sourceIdType: ''
		}
		setSourceFileInfo((prev) => [newSource, ...prev]);
	}

	const deleteSourceDocument = (index: number) => {
		setSourceFileInfo((prev) => prev.filter((item, idx) => idx !== index));
		const tempState = {...selectedHoaDocuments[title]};
		tempState.files = tempState.files.filter((item: any, idx: number) => idx !== index);
		let updatedInfo = {
			...selectedHoaDocuments,
			[title]: tempState
		}
		checkDocumentWarning(updatedInfo);
		updateSelectedHoaDocuments(updatedInfo);
    }

	const handleSourceFile = (event: any, index: number) => {
		const {name, value} = event.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === 'files' && value.length > 0) {
			tempState[index]['isVerified'] = true;
        } else if (name === 'files' && value.length == 0) {
			tempState[index]['isVerified'] = false;
        }
		setSourceFileInfo(tempState);
	}

	const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified);

	return (
		<Modal open={open}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div style={{ background: "#EFF4FC" }}>
					<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
						<div className="modal-title-container" >
							<span className="text-3E3E3E-20px bold">Upload Document</span>
							<span className="text-5B5B5B-14px  normal">
								Please give the necessary information.
							</span>
						</div>
						<IconButton
							onClick={() => onClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
				</div>
				<div className="modal-wrapper-doc">
					<CustomDateField 
						label="Amendment Date"
						error={false}
						variant="filled"
						style={{width: '216px', margin: '2px'}}
						value={dayjs(selectedHoaDocuments[title]?.AmendmentDate || null)}
						handleChange={(value: any) => handleDocument(value, 'AmendmentDate')}
						isClearable={{ clearable: selectedHoaDocuments[title]?.AmendmentDate? true: false, onClear: handleClearAmendmentDate }}
					/>
					<div style={{ marginTop: "8px" }}>
						{
							selectedHoaDocuments[title]?.hyperLink.map((link: any, index: number) => (
								<Stack direction={`row`}>
								<TextField
									style={{
										width: "442px",
										margin: "2px",
									}}
									variant="filled"
									value={link}
									error={error?.link}
									helperText={error.link ? "Provide Valid Url" : ""}
									onChange={(e) => {
										if (error.link) {
											setError({
												...error,
												link: false,
											});
										}
										handleHyperLink(e.target.value, index)
									}}
									label="Hyper Link"
									InputProps={{
										endAdornment: <LinkIcon />,
									}}
								/>
								<IconButton>
									{index !== 0 && <RemoveCircleOutline onClick={()=>removeHyperLink(index)} />}
								</IconButton>
							</Stack>
							))
						}
						<Button onClick={addMoreLink} style={{marginTop: '24px', width: '158px'}}  startIcon={<AddIcon color="primary"/>} variant="outlined">
							Add Another
						</Button>
					</div>
				</div>
				<div className="upload-wrappper-doc">
					<Stack direction={'row'} alignItems='center' spacing={2}>
						<Button
							startIcon={<AttachmentIcon color="primary" />}
							variant="outlined"
							disabled={!isAllVerified}
							onClick = {addNewSourceDocument}
						>
							Attach Document
						</Button>
					</Stack>
					<Stack>
						{sourceFileInfo
						.map((item, index) => (
							<SourceIDVerificationCard 
								key={index} 
								index={index}
								item={item}
								loading={loading}
								setLoading={setLoading}
								handleSourceFile={handleSourceFile}
								handleDeleteCard={deleteSourceDocument}
							/>	
						))}
					</Stack>
					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						<Button onClick={() => onClose()} variant="outlined">
							Cancel
						</Button>
						<Button disabled={!isAllVerified} onClick={() => onUploadClick()} variant="contained">
							Upload
						</Button>
					</Stack>
				</div>
			</Container>
		</Modal>
	);
};

const SelectedUploadedDoc = ({
	selectedValues,
	selectedDocument,
	setSelectedDocument,
	selectedDocumentDetails,
	setSelectedDocumentDetails,
	updateSelectedValues,
	toggleDeleteOpen,
	updateHoaData,
	document,
	setDocumentDetails,
	getFormatedDate,
	DownloadDoc,
	deleteOpen,
	view,
	hoa,
	selectedHoaDocuments,
	currentHoa,
	setCurrentHoa,
	hoaDocumentToBeDeleted,
	updateHoaDocumentToBeDeleted,
	createLogs,
	isDocumentDisabled
}: any) => {
	let [title, details]: any = Object.entries(selectedDocumentDetails)[0];
	const [currentVersions, setCurrentVersions] = useState([]);
	const [olderVersions, setOlderVersions] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(null);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>, value: any) => {
		setSelectedDocument(value);
		setCurrentIndex(details?.files.indexOf(value));
	  	setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
	  setAnchorEl(null);
	};

	const deleteClick = () => {
		toggleDeleteOpen(!deleteOpen);
	}
	useEffect(() => {
		if(details && details.files && details.files.length>0){
			let docVersion = null;
			details.files.map((item: any, index: number) => {
				if(item.hasOwnProperty('version') && item.hasOwnProperty('versionName')){
					return;
				}else{
					let extractUrl = item.url?.split('?')[0];
					let extractUrlArray = extractUrl?.split('/')
					docVersion = +extractUrlArray[extractUrlArray.length-1].match(/\d+/g)[0];
					item.version = docVersion;
					item.versionName = 'new';
				}
			})
			setOlderVersions(olderVersion(details.files));
			setCurrentVersions(currentVersion(details.files));
		}
		return () => {
			title = '';
			details = {};
			setCurrentVersions([]);
			setOlderVersions([]);
		}
	},[title, details, selectedDocumentDetails])

	const olderVersion = (files: any) => {
		const data =  files.filter((item: any) => {
			if(item.versionName === 'older'){
				return item;
			}
		})
		return data;
	}

	const currentVersion = (files: any) => {
		const data =  files.filter((item: any) => {
			if(item.versionName === 'new'){
				return item;
			}
		})
		return data;
	}

	const versionChange = async (tag: string) => {
		const tempState = JSON.parse(JSON.stringify(selectedValues))
		if(tag === 'move-to-latest'){
			let updatedDocument = {
				...selectedDocument,
				versionName: 'new',
			}
			setSelectedDocument(updatedDocument);
			details.files[currentIndex] = updatedDocument;
			const updatedDocuments = {
				...document,
				[title]: details,
			};
			setSelectedDocumentDetails({ [title]: details});
			// const res = await DashboardService.updateHoaDocuments(updatedDocuments, selectedValues.objectId);
			// if(res.status === 200){
			// 	createLogs(view,selectedValues.objectId,selectedValues.documents, res?.data?.documents, ['Document Information']);
			// }
			
			tempState.documents = updatedDocuments;
			setCurrentHoa(tempState);
			setCurrentIndex(null);
			// let data = hoa.data;
			// let index = data.findIndex(
			// 	(value: any, index1: number) => value.objectId === selectedValues.objectId
			// );
			// data[index] = selectedValues;
			// updateHoaData({
			// 	...hoa,
			// 	data: data,
			// });
			
			setSelectedDocument({});
		}
		if(tag === 'move-to-older'){
			setSelectedDocument((prev: any) => ({
				...prev,
				versionName: 'older'
			}))
			details.files[currentIndex] = {
				...selectedDocument,
				versionName: 'older'
			}
			const updatedDocuments = {
				...document,
				[title]: details,
			};
			setSelectedDocumentDetails({ [title]: details });
			// const res = await DashboardService.updateHoaDocuments(updatedDocuments, selectedValues.objectId);
			// if(res.status === 200){
			// 	createLogs(view, selectedValues.objectId, selectedValues.documents, res?.data?.documents, ['Document Information']);
			// }
			tempState.documents = updatedDocuments;
			setCurrentHoa(tempState);
			setCurrentIndex(null);
			// let data = hoa.data;
			// let index = data.findIndex(
			// 	(value: any, index1: number) => value.objectId === selectedValues.objectId
			// );
			// data[index] = selectedValues;
			// updateHoaData({
			// 	...hoa,
			// 	data: data,
			// });
			setSelectedDocument({});
		}
	}

	const restoreDocumentClick = (e: any, doc: any) => {
		if(!doc){
			return;
		}
		let data = hoaDocumentToBeDeleted[title].filter((item: any) => {
			if(item.name !== doc.name) return item;
		})
		let updatedObject = {
			...hoaDocumentToBeDeleted,
			[title]: data
		}
		let updateDocumentObject = {
			...selectedDocumentDetails,
			[title]: {
				...selectedDocumentDetails[title],
				files: selectedDocumentDetails[title].files ? [...selectedDocumentDetails[title].files, doc] : [doc]
			}
		}
		const updatedDocuments = {
			...document,
			[title]: updateDocumentObject[title]
		};
		setSelectedDocumentDetails(updateDocumentObject);
		updateHoaDocumentToBeDeleted(updatedObject);
		setDocumentDetails(updatedDocuments)
		selectedValues.documents = updatedDocuments;
		updateSelectedValues(selectedValues);
	}

	return (
		<Stack direction={"column"}>
			<span style={{ paddingBottom: "8px" }} className="text-3E3E3E-16px bold">
				Details
			</span>
			<span style={{ paddingBottom: "8px" }} className="text-787878-12px normal">
				{title}
			</span>

			<Stack
				style={{ overflowY: "scroll", maxHeight: "100px", marginBottom: '10px'}}
				direction={"column"}
				spacing={2}
			>
				{Object.keys(selectedHoaDocuments).length !== 0 && 
				selectedHoaDocuments[title]?.files && selectedHoaDocuments[title]?.files.length > 0
				 && selectedHoaDocuments[title]?.files.map((item: any, index: number) => (
					item?.files && item.files.map((file: any, index1: number) => (
						<div className="doc-wrapper-content" key={index}>
							<Stack direction={"row"} alignItems={"center"}>
								<span className="text-3E3E3E-14px normal">
									{file}
								</span>
							</Stack>
						</div>

					))
				))
				}
			</Stack>
			<Stack
				style={{ overflowY: "scroll", maxHeight: "200px" }}
				direction={"column"}
				spacing={2}
			>
				{/* {details?.files.map((value: any, index: number) => {
					return (
						<div key={index} className="doc-wrapper-content">
							<span className="text-5B5B5B-14px normal">
								{value.name}
							</span>
						</div>
					);
				})} */}
				{currentVersions && currentVersions.length > 0 && currentVersions.map((item: any, index: number) => {
					return (
					<div className="doc-wrapper-content" key={index}>
						<Box>
							<Box className="text-3E3E3E-14px normal">
								{item.name}
							</Box>
							<Box className="text-9F9F9F-12px normal" marginTop="5px">{getFormatedDate(item.uploadedTime)}</Box>
							<Box className="text-9F9F9F-12px normal" marginTop="5px">Doc ID: {item.sourceId ? item.sourceId : "N/A"}</Box>
						</Box>
						{
							view === "update" ?
							<>
							<Tooltip title="Document Versioning">
								<IconButton
								onClick={(e)=>handleClick(e, item)}
								disabled={isDocumentDisabled(title)}
								size="small"
								// sx={{ ml: 2 }}
								aria-controls={open ? 'account-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								>
								<MoreVertIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								</IconButton>
							</Tooltip>
							<Menu
								elevation={0}
								PaperProps={{
									className: "status-menu-box"
								}}
								anchorEl={anchorEl}
								id="account-menu"
								open={open}
								onClose={handleClose}
								onClick={handleClose}
								transformOrigin={{ horizontal: 'right', vertical: 'top' }}
								anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
							>
							<MenuItem  onClick={deleteClick}>
								<DeleteIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								<span style={{marginLeft: '8px'}}>Delete</span>
							</MenuItem>
							<MenuItem  onClick={() => versionChange('move-to-older')}>
								<DriveFileMoveIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								<span style={{marginLeft: '8px'}}>Move To Older Version</span>
							</MenuItem>
							</Menu>
							</>
							: ''
						}
					</div>
				)})}
				{
					hoaDocumentToBeDeleted[title] && hoaDocumentToBeDeleted[title].map((item: any, index: number) => {
						if(item.versionName === 'new'){
							return(
							<div className="doc-wrapper-content" style={{opacity: 0.5}} key={index}>
							<Stack direction={"row"} alignItems={"center"}>
								<span className="text-3E3E3E-14px normal">
								{item?.name}
								</span>
							</Stack>
							<IconButton
								onClick={(e)=>restoreDocumentClick(e, item)}
								size="small"
								// sx={{ ml: 2 }}
								aria-controls={open ? 'account-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								>
								<ReStoreIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
							</IconButton>
							</div>)
						}
					})
				}
				{ currentVersions.length === 0 && olderVersions.length > 0 && (
					<span style={{ marginTop: "5px" }} className="text-787878-12px bold">
						No Versions Available
					</span>
				)}
			</Stack>

			<div style={{ borderBottom: "1px solid #e8e8e8" }}>
				{["Amendment Date", "Last Updated", "Uploaded By"].map(
					(title: string, index: number) => {
						let value = "";
						if (title === "Amendment Date") {
							value = getFormatedDate(details?.amendmentDate);
						} else if (title === "Last Updated") {
							value = getFormatedDate(details?.lastUpdated);
						} else if (title === "Uploaded By") {
							if(datastore.userRole === config.userRoles.OrganizationUser) return null;
							value = details?.uploadedBy;
						}
						return value && (
							<Stack
								style={{ padding: "12px 0px" }}
								key={index}
								justifyContent={"space-between"}
								alignItems={"center"}
								direction={"row"}
							>
								<span className="text-5B5B5B-12px bold">{title}</span>
								<span className="text-3E3E3E-12px normal">{value}</span>
							</Stack>
						);
					}
				)}
			</div>
			<div>
				<Stack
					style={{ padding: "12px 0px" }}
					justifyContent={"space-between"}
					alignItems={"baseline"}
					direction={"row"}
					>
						<span className="text-5B5B5B-12px bold">{`Hyper Links`}</span>
						{Array.isArray(details?.hyperLink) && details?.hyperLink.length === 0 && (
							<span className="text-5B5B5B-12px bold">{`N/A`}</span>
						)}
						<Stack direction={`column`}>
						{Array.isArray(details?.hyperLink) && details?.hyperLink.map((url: string, index: number) => (
							<Stack direction={`row`} alignItems={`center`}>
							<span className="text-5B5B5B-12px bold">Open Link {index+1}</span>
							<Tooltip title="Open Link">
								<IconButton
									onClick={() => {
										window.open(urlCheck(url),'_blank')
									}}
								>
									<OpenInNewIcon
										style={{
											width: "15px",
											height: "15px",
											color: "#3576E5",
										}}
									/>
								</IconButton>
							</Tooltip>
							</Stack>
						))}
						</Stack>
				</Stack>
			</div>
			<span style={{ marginTop: "20px" }} className="text-5B5B5B-14px bold">
				Older Versions
			</span>
			{(olderVersions && olderVersions.length > 0) || Object.keys(hoaDocumentToBeDeleted)[0] ? (
					<OlderVersionsComp title={title} details={details.files} view={view} deleteClick={deleteClick} DownloadDoc={DownloadDoc} getFormatedDate={getFormatedDate} files={olderVersions} versionChange={versionChange} setSelectedDocument={setSelectedDocument} setCurrentIndex={setCurrentIndex} hoaDocumentToBeDeleted={hoaDocumentToBeDeleted} restoreDocumentClick={restoreDocumentClick}/>
			) : (
				<span style={{ marginTop: "5px" }} className="text-787878-12px bold">
					No Versions Available
				</span>
			)}
		</Stack>
	);
};

const OlderVersionsComp = ({ title , details, files, view, deleteClick, getFormatedDate, DownloadDoc, versionChange, setSelectedDocument, setCurrentIndex, hoaDocumentToBeDeleted,restoreDocumentClick }: any) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>, value: any) => {
		setSelectedDocument(value);
		setCurrentIndex(details.indexOf(value));
	  	setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
	  setAnchorEl(null);
	};
	
	return (
		<Stack
			style={{ overflowY: "scroll", maxHeight: "140px" }}
			paddingTop={"10px"}
			spacing={2}
			direction={"column"}
		>
			{files && files.map((value: any, index: number) => {
				return (
					<div className="doc-wrapper-content" key={index}>
						<Box>
							<Box className="text-3E3E3E-14px normal">
							{value.name}
							</Box>
							<Box className="text-9F9F9F-12px normal" marginTop="5px">{getFormatedDate(value.uploadedTime)}</Box>
							<Box className="text-9F9F9F-12px normal" marginTop="5px">Doc ID: {value?.sourceId || value?.id || value?.objectId || "N/A"}</Box>
						</Box>
						{
							view === "update" ?
							
							<>
							<Tooltip title="Document Versioning">
								<IconButton
								onClick={(e)=>handleClick(e, value)}
								size="small"
								// sx={{ ml: 2 }}
								aria-controls={open ? 'account-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								>
								<MoreVertIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								</IconButton>
							</Tooltip>
							<Menu
								elevation={0}
								PaperProps={{
									className: "status-menu-box"
								}}
								anchorEl={anchorEl}
								id="account-menu"
								open={open}
								onClose={handleClose}
								onClick={handleClose}
								transformOrigin={{ horizontal: 'right', vertical: 'top' }}
								anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
							>
							<MenuItem  onClick={deleteClick}>
								<DeleteIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								<span style={{marginLeft: '8px'}}>Delete</span>
							</MenuItem>
							<MenuItem  onClick={() => versionChange('move-to-latest')}>
								<DriveFileMoveIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
								<span style={{marginLeft: '8px'}}>Move To Latest Version</span>
							</MenuItem>
							</Menu>
							</>
							: ''
						}
					</div>
				);
			})}
			{
				hoaDocumentToBeDeleted[title] && hoaDocumentToBeDeleted[title].map((item: any, index: number) => {
					if(item.versionName === 'older'){
						return(
							<div className="doc-wrapper-content" style={{opacity: 0.5}} key={index}>
							<Stack direction={"row"} alignItems={"center"}>
								<span className="text-3E3E3E-14px normal">
								{item?.name}
								</span>
							</Stack>
							<IconButton
								onClick={(e)=>restoreDocumentClick(e, item)}
								size="small"
								// sx={{ ml: 2 }}
								aria-controls={open ? 'account-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								>
								<ReStoreIcon style={{ width: "20px", height: "20px", color: "#3576E5" }}/>
							</IconButton>
							</div>
						)
					}
				})
			}
		</Stack>
	);
};

const GeneratingSignedUrl = ({isLoading}:any) => {

	return (
		<Dialog open={isLoading}>
			<Stack padding={'10px'} direction={'column'} alignItems={'center'}>
				<Box sx={{ display: "flex", alignItems: 'center' }}>
					<CircularProgress />
				</Box>
				<span style={{ paddingTop:'10px' }} className="text-3E3E3E-16px bold">Generating Signed Url</span>
			</Stack>
		</Dialog>
	);
}
